import * as React from 'react';
import isNode from '../../utils/isNode';

export default function withEventTracker(WrappedComponent) {
  const eventTrackerHOC = class extends React.Component {
    constructor() {
      super();

      this.eventTracker = {
        send: this.sendEvent.bind(this),
      };
    }

    sendEvent = (category, action, label, nonInteraction = true, fields) => {
      if (isNode()) return;

      if (window.ga) {
        window.ga('send', 'event', category, action, label, { ...fields, nonInteraction });
      } else {
        console.log(`send event ${category} ${action} ${label}`, { ...fields, nonInteraction });
      }
    };

    render() {
      const { ...wrappedProps } = this.props;
      return (<WrappedComponent eventTracker={this.eventTracker} {...wrappedProps} />);
    }
  };

  return eventTrackerHOC;
}
